// MyFooter.jsx
import React from "react";
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaHeart,
  FaArrowUp,
} from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";
import footerImage from "../images/footer-img.jpg";
import "./MyFooter.css";

const MyFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-bg">
        <img src={footerImage} alt="Footer background" className="footer-bg-image" />
        <div className="footer-bg-overlay"></div>
      </div>

      {/* Decorative Shape Divider */}
      <div className="footer-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C300,100 600,0 900,80 C1100,120 1150,50 1200,30 L1200,0 L0,0 Z" fill="rgba(255,255,255,0.05)"/>
        </svg>
      </div>

      <div className="footer-main">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-column">
            <div className="footer-brand">
              <h3 className="footer-title">
                <span className="title-highlight">Palliative</span> Care
              </h3>
              <div className="brand-line"></div>
            </div>
            <p className="footer-description">
              Delivering dignified, innovative, and comprehensive palliative care
              to the community through a decentralised, volunteer-driven model
            </p>
            <div className="footer-social">
              <a href="https://facebook.com/profile.php?id=100069732319825" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div className="footer-column">
            <h4 className="footer-heading">Get In Touch</h4>
            <div className="contact-list">
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <MdLocationOn />
                </div>
                <span className="text-small">Sub Station Road, Cherani, Manjeri-676123</span>
              </div>
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <MdPhone />
                </div>
                <span>9605767367</span>
              </div>
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <MdEmail />
                </div>
                <span>manjeripalliative@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/historypage">History</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/articles">Articles</Link></li>
              <li><Link to="/research">Research</Link></li>
              <li><Link to="/contactus">Contact Us</Link></li>
            </ul>
          </div>

          {/* Newsletter / CTA Section - New Addition */}
          <div className="footer-column">
            <h4 className="footer-heading">Join Our Mission</h4>
            <p className="newsletter-text">
              Be part of our journey to provide compassionate care to those in need.
            </p>
            <div className="newsletter-box">
              <input type="email" placeholder="Your email" className="newsletter-input" />
              <button className="newsletter-btn">Subscribe</button>
            </div>
            {/* <div className="footer-badge">
              <FaHeart className="heart-icon" />
              <span>Making a difference together</span>
            </div> */}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} Palliative Care Manjeri. 
            <span className="copyright-separator">|</span>
            All Rights Reserved.
          </p>
          <button onClick={scrollToTop} className="back-to-top" aria-label="Back to top">
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default MyFooter;